import { Controller } from '@hotwired/stimulus';
import {
  clearLocalCaseProgress,
  getCurrentUserIdFromDom,
} from '../utils/clear_local_case_progress';

// Connects to data-controller="clear-local-case-progress"
export default class extends Controller {
  static values = {
    documentId: Number,
    userId: Number,
  };

  resolvedUserId() {
    return this.hasUserIdValue ? this.userIdValue : getCurrentUserIdFromDom();
  }

  beforeRemoteReset = async (event) => {
    event.preventDefault();
    await clearLocalCaseProgress(this.documentIdValue, this.resolvedUserId());

    const link = event.currentTarget;
    const method = (link.dataset.turboMethod || 'patch').toUpperCase();
    const response = await fetch(link.href, {
      method,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        Accept: 'text/vnd.turbo-stream.html, text/html, application/json',
      },
      credentials: 'same-origin',
    });

    if (!response.ok) return;

    const body = await response.text();
    if (body && window.Turbo?.renderStreamMessage) {
      window.Turbo.renderStreamMessage(body);
    }
  };

  beforeFormReset = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    await clearLocalCaseProgress(this.documentIdValue, this.resolvedUserId());

    const response = await fetch(form.action, {
      method: (form.method || 'post').toUpperCase(),
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        Accept: 'text/html, application/json, text/vnd.turbo-stream.html',
      },
      body: new FormData(form),
      credentials: 'same-origin',
    });

    if (response.redirected) {
      window.location.assign(response.url);
      return;
    }

    if (response.ok) {
      window.location.reload();
    }
  };
};
